import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Stack,
    Typography,
    Alert
} from '@mui/material';

export default function ProgramarFuturoDialog({ open, onClose, onConfirm, onIgnore, loading, cliente }) {
    const [titulo, setTitulo] = useState("Recontactar cliente");
    const [descripcion, setDescripcion] = useState("");
    const [fecha, setFecha] = useState("");
    const [error, setError] = useState(null);

    // Calcular la fecha mínima (mañana) en formato YYYY-MM-DD
    const getTodayDateString = () => {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1); // ✅ Agregar 1 día
        const year = tomorrow.getFullYear();
        const month = String(tomorrow.getMonth() + 1).padStart(2, '0');
        const day = String(tomorrow.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // Resetear estados al abrir
    useEffect(() => {
        if (open) {
            const nombreCliente = 
                cliente?.clienteNombre || 
                cliente?.nombreCliente || 
                "";
            const tituloBase = nombreCliente 
                ? `Recontactar cliente "${nombreCliente}"`
                : "Recontactar cliente";
            
            setTitulo(tituloBase);
            setDescripcion("");
            setFecha("");
            setError(null);
        }
    }, [open, cliente]);

    const handleConfirm = () => {
        if (!titulo.trim()) {
            setError("El título es obligatorio");
            return;
        }
        if (!fecha) {
            setError("Debes seleccionar una fecha");
            return;
        }

        // Desglosamos la fecha del input (YYYY-MM-DD)
        const [year, month, day] = fecha.split('-').map(Number);

        // Creamos la fecha a las 05:00 AM hora local
        // (Mes es 0-indexado)
        const fechaProgramada = new Date(year, month - 1, day, 5, 0, 0);

        // Simple validación: no permitir fechas anteriores al día actual (00:00)
        const todayZero = new Date();
        todayZero.setHours(0, 0, 0, 0);

        if (fechaProgramada < todayZero) {
            setError("La fecha no puede ser anterior a hoy");
            return;
        }

        onConfirm({
            titulo,
            descripcion,
            fecha_programada: fechaProgramada.toISOString()
        });
    };

    return (
        <Dialog open={Boolean(open)} onClose={!loading ? onClose : undefined} maxWidth="sm" fullWidth>
            <DialogTitle>Programar seguimiento a Futuro</DialogTitle>
            <DialogContent>
                <Stack spacing={3} sx={{ mt: 1 }}>
                    <Typography variant="body2" color="text.secondary">
                        Este cliente pasará a la pestaña <b>FUTURO</b>.
                    </Typography>

                    {error && <Alert severity="error">{error}</Alert>}

                    <TextField
                        label="Título de la notificación"
                        value={titulo}
                        onChange={(e) => setTitulo(e.target.value)}
                        fullWidth
                        disabled={loading}
                    />

                    <TextField
                        label="Descripción / Notas"
                        value={descripcion}
                        onChange={(e) => setDescripcion(e.target.value)}
                        multiline
                        rows={3}
                        fullWidth
                        placeholder="Ej: Llamar para ofrecer nueva promoción..."
                        disabled={loading}
                    />

                    <TextField
                        label="Fecha de programación"
                        type="date"
                        value={fecha}
                        onChange={(e) => setFecha(e.target.value)}
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        disabled={loading}
                        inputProps={{
                            min: getTodayDateString(),
                            max: "2099-12-31",
                        }}
                    />
                </Stack>
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button onClick={onClose} disabled={loading} color="inherit">
                    Cancelar
                </Button>
                <Button onClick={onIgnore} disabled={loading} color="warning">
                    Ignorar (No notificar)
                </Button>
                <Button onClick={handleConfirm} disabled={loading} variant="contained">
                    {loading ? "Procesando..." : "Programar"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}